export var TimeFrame;
(function (TimeFrame) {
    TimeFrame[TimeFrame["SevenDays"] = 0] = "SevenDays";
    TimeFrame[TimeFrame["ThirtyDays"] = 1] = "ThirtyDays";
    TimeFrame[TimeFrame["NinetyDays"] = 2] = "NinetyDays";
    TimeFrame[TimeFrame["Annual"] = 3] = "Annual";
    TimeFrame[TimeFrame["All"] = 4] = "All";
})(TimeFrame || (TimeFrame = {}));
